module.exports = __webpack_public_path__ + "static/media/imgComing.ab275ed1.svg";